import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Switch,
  Cascader,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {updateUser, fetchUsers, updatePass} from 'appRedux/actions/Users'

const FormItem = Form.Item

class Basic extends React.Component {
  state = {
    visible: false,
    identification: '',
    name: '',
    phone: '',
    email: '',
    id: '',
    accountType:'',

    validateStatus:'',
    validateIden: '',
    validateName: '',
    validatePhone: '',
    validateEmail: '',
    validateId: '',

    helpIden: '',
    helpName: '',
    helpPhone: '',
    helpEmail: '',
    helpId: '',

    pass: '',
    passReal: '',
    password: '',

    validatePass: '',
    helpPass: '',
  }

  showModal = () => {
    this.setState({
      visible: true,
      identification: this.props.recording.identification,
      id: this.props.recording.id,
      name: this.props.recording.name,
      phone: this.props.recording.phone,
      email: this.props.recording.email,
      accountType:this.props.recording.acccountType
    })
        console.log('my props',this.props)

    console.log('my props',this.props.recording)
    console.log('my state',this.state)
  }

  handleCancel = e => {
    this.setState({
      id:'',
      name: '',
      identification: '',
      email: '',
      phone: '',
      pass: '',
      password: '',
      accountType:'',
    })

    this.props.fetchUsers()
    this.setState({visible: false})
    if (this.state.name == '') {
      this.setState({validateName: '', helpName: ''})
    }
    if (this.state.id == '') {
      this.setState({validateId: '', helpId: ''})
    }
    if (this.state.email == '') {
      this.setState({validateEmail: '', helpEmail: ''})
    }
    if (this.state.identification == '') {
      this.setState({validateIden: '', helpIden: ''})
    }
    if (this.state.phone == '') {
      this.setState({validatePhone: '', helpPhone: ''})
    }
    if (this.state.password == '') {
      this.setState({validatePass: '', helpPass: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'El usuario se ha modificado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al modificar el usuario.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {id, identification, name, email, phone,accountType} = this.state
    if (this.state.validateStatus != 'error') {
      if (id && identification && name && email && phone != '' && accountType!='') {
        this.props.updateUser(this.state, () => {
          this.props.fetchUsers()
        })

        this.onNotification('success', 'El usuario se ha editado con éxito')
      } else {
        if (this.state.id == '') {
          this.setState({
            validateId: 'error',
            helpId: 'Id es un campo obligatorio.',
          })
        } else {
          this.setState({validateId: '', helpId: ''})
        }
        if (this.state.identification == '') {
          this.setState({
            validateIden: 'error',
            helpIden: 'Identificacion es un campo obligatorio.',
          })
        } else {
          this.setState({validateIden: '', helpIden: ''})
        }
        if (this.state.name == '') {
          this.setState({
            validateName: 'error',
            helpName: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateName: '', helpName: ''})
        }
        if (this.state.phone == '') {
          this.setState({
            validatePhone: 'error',
            helpPhone: 'Precio es un campo obligatorio.',
          })
        } else {
          this.setState({validatePhone: '', helpPhone: ''})
        }
        if (this.state.email == '') {
          this.setState({
            validateEmail: 'error',
            helpEmail: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateEmail: '', helpEmail: ''})
        }
        this.onNotification(
          'error',
          'Rellene los campos obligatorios',
        )
      }
    } 
  }
  onChangeAccountType = (value) => {

    
    this.setState({
      accountType:value[0]
    })
    console.log(this.state);
    
}
  changePass= () =>{
    let {pass, passReal, password, email} = this.state
      if (pass && password != '' && pass == password) {
        console.log(passReal, email);
        this.props.updatePass(email, passReal)
        this.onNotification('success', 'La contraseña se ha editado con éxito')
  }else{
    this.onNotification(
      'error',
      'No se ha podido cambiar la contraseña, verifique los datos.',
    )
  }
}


  render() {
       const optionsAccount = [
      {
          key: '1',
        value: '1',
        label: 'Personal',
     
      },
      {   key: '2',
        value: '2',
        label: 'Empresa',
   
      },
    ]
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchUsers()}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar usuario">
            <form onSubmit={this.onHandleClick}>
            <Row className="padding-modal">

              <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Cédula"
                    validateStatus={this.state.validateIden}
                    help={this.state.helpIden}
                  >
                    <Input
                      required
                      placeholder="Cédula"
                      value={this.state.identification}
                      onChange={event => {
                        this.setState({
                          identification: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateIden: '',
                            helpIden: '',
                          })
                        } else {
                          this.setState({
                            validateIden: 'error',
                            helpIden: 'Identificación es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Nombre"
                    validateStatus={this.state.validateName}
                    help={this.state.helpName}
                  >
                    <Input
                      required
                      placeholder="Nombre"
                      value={this.state.name}
                      onChange={event => {
                        this.setState({
                          name: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateName: '',
                            helpName: '',
                          })
                        } else {
                          this.setState({
                            validateName: 'error',
                            helpName: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Correo"
                    validateStatus={this.state.validateEmail}
                    help={this.state.helpEmail}
                  >
                    <Input
                      required
                      placeholder="Correo electrónico"
                      value={this.state.email}
                      onChange={event => {
                        this.setState({
                          email: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateEmail: '',
                            helpEmail: '',
                          })
                        } else {
                          this.setState({
                            validateEmail: 'error',
                            helpEmail: 'Correo es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Teléfono"
                    validateStatus={this.state.validatePhone}
                    help={this.state.helpPhone}
                  >
                    <Input
                      required
                      placeholder="Número de télefono"
                      value={this.state.phone}
                      onChange={event => {
                        this.setState({
                          phone: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatePhone: '',
                            helpPhone: '',
                          })
                        } else {
                          this.setState({
                            validatePhone: 'error',
                            helpPhone: 'Telefono es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                 
                </Col>

                             
                <Col lg={12} md={12} sm={12} xs={12}>
                        <FormItem
      label="Tipo de cuenta"
        labelCol={{xs: 12, sm: 12, lg: 12, md: 12}}
  
      >
        <Cascader
          defaultValue={[
            `${this.props.recording.acccountType}`,
           
          ]}
          options={optionsAccount}
          onChange={this.onChangeAccountType}
    /*      onChange={() => {
        
            this.props.updateStatusOrder(this.props.recording.id, this.order_status );
            this.onNotification('success');
          }}*/
          placeholder="Por favor selecciona"
        />
      </FormItem>
    </Col>
                </Row>
                <Card title="Opcional">
                <Row className="padding-modal">
                <Col lg={5} md={5} sm={5} xs={5}>                  
                <FormItem
                    label="Contraseña"
                    validateStatus={
                      this.state.validateStatus ||
                      this.state.validatePass
                    }
                    help={this.state.help || this.state.helpPass}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={19} md={19} sm={19} xs={19}>
                    <Input
                      required
                      type="password"
                      placeholder="Contraseña"
                      value={this.state.password}
                      onChange={event => {
                        this.setState({
                          password: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatePass: '',
                            helpPass: '',
                          })
                        } else {
                          this.setState({
                            validatePass: 'error',
                            helpPass:
                              'Password es un campo obligatorio.',
                          })
                        }

                        if (this.state.pass === event.target.value) {
                          this.setState({
                            validateStatus: '',
                            help: '',
                            passReal: event.target.value,
                          })
                        } else {
                          this.setState({
                            validateStatus: 'error',
                            help: 'Las contraseñas no coinciden',
                          })
                        }
                      }}
                    />
                  
                </Col>

                <Col lg={5} md={5} sm={5} xs={5}> 
                  <FormItem
                    label="Validación"
                    validateStatus={this.state.validateStatus}
                    help={this.state.help}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={19} md={19} sm={19} xs={19}>
                    <Input
                      required
                      type="password"
                      placeholder="Validar contraseña"
                      value={this.state.pass}
                      onChange={event => {
                        this.setState({
                          pass: event.target.value,
                        })
                        if (this.state.password === event.target.value) {
                          this.setState({
                            validateStatus: '',
                            help: '',
                            passReal: event.target.value,
                          })
                        } else {
                          this.setState({
                            validateStatus: 'error',
                            help: 'Las contraseñas no coinciden',
                          })
                        }
                      }}
                    />
                  
                </Col>
                
   
              </Row>
              <Button type="primary" onClick={this.changePass}>
                Cambiar contraseña
              </Button>
              </Card>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({users}) {
  return {
    users,
  }
}
export default connect(
  mapStateToProps,
  {fetchUsers, updateUser, updatePass},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Admin/ModalEdit.js